import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ToolingRoute from "Tooling";
import AccessManager from "routes/routes/Tooling/routes/AccessManager";
import OrganizationV2 from "routes/routes/Tooling/routes/OrganizationV2";
import UserFeed from "routes/routes/Tooling/routes/User";
import Configurations from "Tooling/routes/Configurations";
import ManageProgrammes from "Tooling/routes/ManageProgrammes";
import RolesAndPermissionsTool from "Tooling/routes/RolesAndPermissionsTool";
import ProductRequest from "Tooling/routes/InternalTools/routes/ProductRequest";
import LRTDashboard from "Tooling/routes/InternalTools/routes/LRTDashboard";
import InternalTools from "Tooling/routes/InternalTools";
import StandardV2 from "Tooling/routes/StandardV2";
import TemplateEditor from "Tooling/routes/TemplateEditor";
import OrganizationApproval from "Tooling/routes/OrganizationApproval";
import ProgressReportTemplateEditor from "Tooling/routes/ProgressReportTemplateEditor";
import AccessManagerV2 from "Tooling/routes/AccessManagerV2";
import CacheManager from "Tooling/routes/CacheManager";

const getRouteObject = store => {
  return {
    path: "pam",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "pam" */ "./components"),
        import(/* webpackChunkName: "pam" */ "Tooling/modules/ToolingModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const Component = importedModule0.default;
        const toolingReducer = importedModule1.default;
        injectReducer(store, {
          key: "tooling",
          reducer: toolingReducer,
        });
        return Component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
    childRoutes: [
      CacheManager(store),
      InternalTools(store),
      StandardV2(store),
      TemplateEditor(store),
      OrganizationApproval(store),
      ProgressReportTemplateEditor(store),
      ProductRequest(store),
      LRTDashboard(store),
      ManageProgrammes(store),
      AccessManager(store),
      AccessManagerV2(store),
      Configurations(store),
      RolesAndPermissionsTool(store),
      OrganizationV2(store),
      UserFeed(store),
      ToolingRoute(store),
    ],
  };
};
export default getRouteObject;
